// Number formatting used across the UI. Keep formats identical to the backend fact sheet
// (backend/app/ai/facts.py) so users see the same figures in tables, charts and AI text.

const nf0 = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });
const nf1 = new Intl.NumberFormat('en-US', { maximumFractionDigits: 1, minimumFractionDigits: 1 });

export function usd(x: number | null | undefined): string {
  if (x == null || !Number.isFinite(x)) return 'n/a';
  const sign = x < 0 ? '−' : '';
  const a = Math.abs(x);
  if (a >= 1e9) return `${sign}$${nf1.format(a / 1e9)}bn`;
  if (a >= 1e6) return `${sign}$${nf0.format(a / 1e6)}M`;
  return `${sign}$${nf0.format(a)}`;
}

export function usdT(x: number | null | undefined): string {
  if (x == null || !Number.isFinite(x)) return 'n/a';
  return `${x < 0 ? '−' : ''}$${nf0.format(Math.abs(x))}/t`;
}

export function pct(x: number | null | undefined, digits = 1): string {
  if (x == null || !Number.isFinite(x)) return 'n/a';
  return `${(x * 100).toFixed(digits)}%`;
}

export function num(x: number | null | undefined, digits = 0): string {
  if (x == null || !Number.isFinite(x)) return 'n/a';
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: digits, minimumFractionDigits: digits }).format(x);
}

export function humanPath(path: string): string {
  return path.replace(/^locations\./, '').replace(/^routes\./, '').replace(/\./g, ' › ').replace(/_/g, ' ');
}

export function dateTime(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}

/** Compact axis tick label for chart axes. */
export function tick(x: number, unit: string): string {
  if (unit === 'share' || unit === 'share of capex') return `${Math.round(x * 1000) / 10}%`;
  if (Math.abs(x) >= 1000) {
    // Keep one decimal when needed so adjacent ticks (1,100 / 1,400) stay distinguishable.
    const k = x / 1000;
    return `${Number.isInteger(k) ? nf0.format(k) : k.toFixed(1)}k`;
  }
  return nf0.format(x) === '0' && x !== 0 ? String(x) : num(x, Math.abs(x) < 10 ? 2 : 0);
}
